import React, { useState } from "react";
import {
  Input,
  Switch,
  Checkbox,
  Text,
  Icon,
  Box,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  useDisclosure,
} from "@chakra-ui/react";
import Select from "react-select";
import moment from "moment";

const TdType = (props) => {
  const {
    value,
    inputType,
    onEnterPressed,
    link,
    customStyle,
    text,
    title,
    modalTitle,
    onChange,
  } = props;
  const defaultProps = {
    fontSize: props.fontSize || "0.75rem",
    errorBorderColor: props.errorBorderColor || "red.300",
    text: props.text || "",
    placeholder: props.placeholder || "Elija una opción",
    borderColor: props.borderColor || "cornflowerblue",
  };
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [modalValue, setModalValue] = useState(value);
  moment.locale();

  const typeSelector = () => {
    switch (inputType) {
      case "input":
        return (
          <Input
            {...props}
            {...defaultProps}
            onKeyDown={(e) => {
              e.key === "Enter" && onEnterPressed();
            }}
            padding={"0.25rem 0.5rem"}
          />
        );

      case "date":
        return (
          <Input
            {...props}
            {...defaultProps}
            value={value || moment().format("YYYY-MM-DD")}
            type="date"
          />
        );

      case "select":
        return <Select {...props} value={value} />;

      case "checkbox":
        return <Checkbox {...props}></Checkbox>;

      case "switch":
        return <Switch d="flex" justifyContent="center" {...props} />;

      case "icon":
        return (
          <Box textAlign="center">
            <a href={link}>
              <Icon
                {...props}
                {...defaultProps}
                as={props.icon}
                _hover={{
                  cursor: "pointer",
                }}
              />
            </a>
          </Box>
        );

      case "modal":
        return (
          <Box textAlign="left">
            <Text
              as="span"
              fontSize={"0.8rem"}
              onClick={() => onOpen()}
              cursor={"pointer"}
              textDecoration={"underline"}
              color={"#3498DB"}
            >
              {value?.label ?? title}
            </Text>
            <Modal isOpen={isOpen} onClose={() => onClose()} size={"md"}>
              <ModalOverlay />
              <ModalContent>
                <ModalHeader textTransform="uppercase" fontSize="1rem">
                  {modalTitle}
                </ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                  <Select
                    {...props}
                    {...defaultProps}
                    value={modalValue}
                    onChange={(val) => setModalValue(val)}
                  />
                </ModalBody>

                <ModalFooter>
                  <Button variant="ghost" mr={3} onClick={() => onClose()}>
                    Cancelar
                  </Button>
                  <Button
                    colorScheme="blue"
                    onClick={() => {
                      onChange(modalValue);
                      onClose();
                    }}
                  >
                    Aceptar
                  </Button>
                </ModalFooter>
              </ModalContent>
            </Modal>
          </Box>
        );

      default:
        return (
          <Box>
            <Text {...customStyle} noOfLines="1" title={title ?? text}>
              {text}
            </Text>
          </Box>
        );
    }
  };

  return <>{typeSelector()}</>;
};

export default TdType;
